import type { IAttributes, IAugmentedJQuery, IDirective, IScope } from 'angular';
import * as angular from 'angular';

function linkMxKeyboardActivation(scope: IScope, element: IAugmentedJQuery, attrs: IAttributes) {
	const expression = attrs.mxKeyboardActivation;

	element.on('keydown', (event: JQuery.KeyDownEvent) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			scope.$apply(() => {
				scope.$eval(expression);
			});
		}
	});

	scope.$on('$destroy', () => {
		element.off('keydown');
	});
}

export const MxKeyboardActivationDirective: IDirective = {
	restrict: 'A',
	link: linkMxKeyboardActivation,
};

function mxKeyboardActivationDirectiveFactory() {
	return MxKeyboardActivationDirective;
}

export function registerMxKeyboardActivationDirective(module: angular.IModule) {
	module.directive('mxKeyboardActivation', mxKeyboardActivationDirectiveFactory);
}
